module.exports = __webpack_public_path__ + "img/buy-sell.def8b834.jpg";